import { showBooks } from "../actions";

const fetchBooks = async (dispatch) => {
  const URL = "https://assignment4-bookstore-server-tanviranindo.glitch.me/books";

  const response = await fetch(URL);
  const books = await response.json();

  if (response.status === 200) {
    dispatch(showBooks(books));
  }
};

export default fetchBooks;
